import {api} from '@/api';
import {convertObjectToURIParam, deepCopyObject} from "@/utils";

const curriculumPrefix = '/teaching/curriculum';
const newMethodPrefix = '/teaching/newMethod';
const masterPrefix = '/teaching/mster';
const advisingPrefix = '/teaching/advising';

// curriculum
export async function getCurriculumList(searchParams){
    let paramStr = await convertObjectToURIParam(searchParams);
    let response = await api.get(curriculumPrefix + '/list' + paramStr);

    return response.data;
}

export async function getCurriculumYearList(){
    let response = await api.get(curriculumPrefix + '/yearList');
    return response.data;
}

export async function getCurriculumScore(year){
    let response = await api.get(curriculumPrefix + '/scoreText?year=' + year);
    return response.data;
}

// newMethod
export async function getnewMethodList(searchParams){
    let paramStr = await convertObjectToURIParam(searchParams);
    let response = await api.get(newMethodPrefix + '/list' + paramStr);
    return response.data;
}

export async function getnewMethodYearList(){
    let response = await api.get(newMethodPrefix + '/yearList');
    return response.data;
}

// master
export async function getMasterList(searchParams){
    let paramStr = await convertObjectToURIParam(searchParams);
    let response = await api.get(masterPrefix + '/list' + paramStr);
    return response.data;
}

export async function getMasterYearList(){
    let response = await api.get(masterPrefix + '/yearList');
    return response.data;
}

// Student Advising
export async function getStudentAdvisingList(searchParams){
    let paramStr = await convertObjectToURIParam(searchParams);
    let response = await api.get(advisingPrefix + '/list' + paramStr);
    return response.data;
}

export async function getStudentAdvisingYearList(){
    let response = await api.get(advisingPrefix + '/yearList');
    return response.data;
}

export async function getStudentAdvisingDetail(id){
    return await api.get(advisingPrefix + '/detail' + '?id=' + id);
}

export async function saveStudentAdvisingDetail(savedStudentAdvising){
    let requestBody = await deepCopyObject(savedStudentAdvising);
    let response = await api.post(advisingPrefix + '/save', requestBody);
    return response;
}

export async function deleteStudentAdvisingByIds(ids){
    await api.post(advisingPrefix + '/delete?deleteIds=' + ids);
    window.location.reload();
}